import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
// EXP_CLEARER_FREE_TRIAL
import { useClearerFreeTrialExp } from '@/components/experiments/ClearerFreeTrialExp';
// EXP_CLEARER_FREE_TRIAL


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionRowCTA',
  props: {
    isHighlighted: { type: Boolean },
    hasPromotionTag: { type: Boolean },
    fullWidth: { type: Boolean },
    providerShortName: null,
    isFallback: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	isHighlighted?: boolean;
	hasPromotionTag?: boolean;
	fullWidth?: boolean;
	// EXP_CLEARER_FREE_TRIAL: only the free trial row passes these - other callers (SQTV, QTV, etc.)
	// leave them undefined, which keeps this button out of the experiment entirely.
	providerShortName?: string;
	isFallback?: boolean;
};



// EXP_CLEARER_FREE_TRIAL - variant_1, variant_2 and variant_4 use the neutral (non-yellow) button; variant_3 and control use yellow.
const { variant: cftrVariant } = useClearerFreeTrialExp(
	() => props.providerShortName,
	() => !!props.isFallback
);
const NEUTRAL_CFTR_VARIANTS = ['variant_1', 'variant_2', 'variant_4'];
const isNeutralCftrVariant = computed(() => NEUTRAL_CFTR_VARIANTS.includes(cftrVariant.value ?? ''));
// EXP_CLEARER_FREE_TRIAL

return { __sfc: true,props, cftrVariant, NEUTRAL_CFTR_VARIANTS, isNeutralCftrVariant, faPlay }
}

})